import React, { useEffect } from 'react';
import { useNavigate } from "react-router";
import { supabase } from '../services/supabase';
import { useAuthStore } from '../stores/authStore';
import Spinner from '../components/primitives/Spinner';
import { MESAJE, PAGE_METADATA } from '@buzunarul/shared-constants';
import { DEPLOYMENT_CONFIG, ACCESS_CONTROL } from '@buzunarul/shared-constants/access-control';
import toast from 'react-hot-toast';
import { cn, dashboard } from '../styles/cva-v2';

// Document metadata
import { useDocumentMeta } from '../hooks/useDocumentMeta';

const AuthCallbackPage = () => {
  // Document metadata
  useDocumentMeta({
    title: PAGE_METADATA.AUTH.CALLBACK.title,
    description: PAGE_METADATA.AUTH.CALLBACK.description,
  });

  const navigate = useNavigate();
  const { setUser } = useAuthStore();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Obținem sesiunea din URL hash
        const { data, error } = await supabase.auth.getSession();

        if (error) {
          console.error('Auth callback error:', error);
          toast.error(MESAJE.GOOGLE_AUTH_ERROR);
          navigate('/login');
          return;
        }

        if (data.session?.user) {
          const userEmail = data.session.user.email || '';
          
          // 🔐 VERIFICARE ACCESS CONTROL: Verifică dacă emailul este aprobat
          if (DEPLOYMENT_CONFIG.IS_BETA_TESTING && !DEPLOYMENT_CONFIG.isEmailApproved(userEmail)) {
            console.warn('Google auth attempt with non-approved email:', userEmail);
            
            // Delogăm user-ul pentru că nu este aprobat
            await supabase.auth.signOut();
            
            toast.error(ACCESS_CONTROL.REGISTRATION_RESTRICTED);
            navigate('/login');
            return;
          }

          // Setăm user-ul în store doar dacă este aprobat
          setUser({
            id: data.session.user.id,
            email: userEmail,
          });

          toast.success(MESAJE.GOOGLE_AUTH_SUCCESS);
          navigate('/daily'); // Redirecționăm către pagina principală
        } else {
          // Dacă nu avem sesiune, redirecționăm către login
          navigate('/login');
        }
      } catch (error) {
        console.error('Unexpected auth callback error:', error);
        toast.error(MESAJE.GOOGLE_AUTH_ERROR);
        navigate('/login');
      }
    };

    handleAuthCallback();
  }, [navigate, setUser]);

  return (
    <div
      className={cn(
        dashboard({ layout: 'compact' }),
        'flex flex-col justify-center items-center min-h-screen'
      )}
    >
      <Spinner size="xl" />
      <p className="mt-4 text-sm text-gray-600">
        Se procesează autentificarea...
      </p>
    </div>
  );
};

export default AuthCallbackPage;